import { css } from '@/styled-system/css';

export const emptyStateTitleTextStyles = css.raw({
  textStyle: 'heading-xs',
  marginBottom: 'tightest',
});

export const emptyStateBodyTextStyles = css.raw({
  display: 'block',
  marginBottom: 'default',
});

export const noUnderlineAnchorStyles = css.raw({
  textDecoration: 'none',
  color: 'inherit',
});

export const emptyStateContainerStyles = css.raw({
  textAlign: 'left',
});

export const iconContainerStyles = css.raw({
  marginBottom: 'default',
});
